module.exports = __webpack_public_path__ + "img/arrow_previous.b12d6b8d.png";